module.exports = __webpack_public_path__ + "img/SHIPPING.aaa40a8c.svg";